import { Component, computed, inject, input, output, resource } from '@angular/core';
import { AnalysisConsumptionFilters } from '../../../analysis/components/analysis-consumption-filters/analysis-consumption-filters';
import { AnalysisConsumptionGraphCard } from '../../../analysis/components/analysis-consumption-graph-card/analysis-consumption-graph-card';
import { AnalysisConsumptionDetailsKpiCard } from '../../../analysis/components/analysis-consumption-details-kpi-card/analysis-consumption-details-kpi-card';
import { AnalysisConsumptionDetailsPeakloadKpiCard } from '../../../analysis/components/analysis-consumption-details-peakload-kpi-card/analysis-consumption-details-peakload-kpi-card';
import { ConsumptionFilter, LoadCurveState } from '../../../analysis/stores/consumption.store';
import { EnergyInterfaceListResponse } from '../../../../core/clients/omni-core/models';
import {
  listEnergyInterfaces,
  ListEnergyInterfaces$Params,
} from '../../../../core/clients/omni-core/functions';
import { Api } from '../../../../core/clients/omni-core/api';

@Component({
  selector: 'app-location-consumption-graph',
  imports: [
    AnalysisConsumptionFilters,
    AnalysisConsumptionGraphCard,
    AnalysisConsumptionDetailsKpiCard,
    AnalysisConsumptionDetailsPeakloadKpiCard,
  ],
  templateUrl: './location-consumption-graph.html',
})
export class LocationConsumptionGraph {
  private api = inject(Api);

  organizationId = input.required<string>();
  locationId = input.required<string>();

  filter = input.required<ConsumptionFilter>();
  data = input.required<LoadCurveState | null>();

  private utilityType = computed(() => this.filter().data.utilityType);
  private flowDirection = computed(() => {
    const direction = this.filter().data.direction;
    return direction === 'PRODUCTION' ? 'FEED_IN' : direction;
  });

  protected energyInterfaces = resource<EnergyInterfaceListResponse, ListEnergyInterfaces$Params>({
    params: () => ({
      id: this.organizationId(),
      limit: 999,
      locationID: this.locationId(),
      utilityType: this.utilityType(),
      flowDirection: this.flowDirection(),
    }),
    loader: ({ params }) => this.api.invoke(listEnergyInterfaces, params),
  });

  clickReload = output<ConsumptionFilter>();
  changeFilter = output<ConsumptionFilter>();

  protected onChangeDate(date: Date) {
    const filter = this.filter();
    this.changeFilter.emit({ ...filter, date });
  }

  protected onChangeGranularity(granularity: ConsumptionFilter['granularity']) {
    const filter = this.filter();
    this.changeFilter.emit({ ...filter, granularity });
  }

  protected onChangeConsumptionFilters(filter: ConsumptionFilter) {
    this.changeFilter.emit(filter);
  }
}
